export const dateFormat = 'YYYY-MM-DD' as const
export const dateTimeFormat = 'YYYY-MM-DD hh:mm:ss' as const

export type ApiRowSummary = {
  school_id: number
  school_title: string
  building_title: string
  sale_point_id: number
  sale_point_title: string
  status: number
  comment: string | null
  balance_at_the_beginning: number // остаток на начало смены
  revenue: number // выручка
  collected: number // сдано
  balance_at_the_end: number // остаток на конец смены
  encashments_count: number // кол-во инкассаций
  pending_dates: Array<string>
}

export type ApiRowEncashment = {
  id: 1
  time: string //"2025-03-13T11:15:35+03:00"
  balance_at_the_beginning: number
  revenue: number
  collected: number
  balance_at_the_end: number
}

export const statusParams = {
  '0': 'cashAccepted', //'Наличные приняты'
  '1': 'cashRefused', //'Отказано'
  '2': 'waitingForCash', //'Ожидает принятия наличных'
  '-1': 'cashNotDeposited', //'Наличные не сданы'
}

export type ApiStatusesType = {
  // сумма по каждому статусу
  '-1': number
  '0': number
  '1': number
  '2': number
}
